"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var checkHasErrorIban = function checkHasErrorIban(values) {
  var response = false;

  for (var ibanField in values) {
    var value = values[ibanField];

    if (/^iban_field_[1-6]$/.test(ibanField) && !/^[a-zA-Z0-9]+$/.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 3) {
      response = true;
      break;
    }

    if (ibanField === "iban_field_7" && !/^[a-zA-Z0-9]+$/.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 2) {
      response = true;
      break;
    }
  }

  return response;
};

exports.default = checkHasErrorIban;